import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AuthPage from "../pages/auth/page";
import DoanhNghiep from "../pages/doanh-nghiep/page";
import BusinessAuthPage from "../pages/doanh-nghiep/auth/page";
import AdminDashboard from "../pages/admin/page";
import AccountPage from "../pages/account/page";
import SavedJobsPage from "../pages/saved-jobs/page";
import AboutUs from "../pages/about/page";
import PrivacyPolicy from "../pages/privacy/page";
import TermsOfService from "../pages/terms/page";
import CompanyProfile from "../pages/company-profile/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/dang-nhap",
    element: <AuthPage />,
  },
  {
    path: "/tai-khoan",
    element: <AccountPage />,
  },
  {
    path: "/viec-lam-da-luu",
    element: <SavedJobsPage />,
  },
  {
    path: "/doanh-nghiep",
    element: <DoanhNghiep />,
  },
  {
    path: "/doanh-nghiep/dang-nhap",
    element: <BusinessAuthPage />,
  },
  {
    path: "/admin",
    element: <AdminDashboard />,
  },
  {
    path: "/gioi-thieu",
    element: <AboutUs />,
  },
  {
    path: "/chinh-sach-bao-mat",
    element: <PrivacyPolicy />,
  },
  {
    path: "/dieu-khoan-su-dung",
    element: <TermsOfService />,
  },
  {
    path: "/nha-tuyen-dung/:slug",
    element: <CompanyProfile />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;